import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import * as select from '../data/selectors'
import { Field } from 'formik'
import {  FormikSelectComponent } from '../../../utilities/formUtils'


const LocationSearch = ({ name, isTxn, isLabel, label, isSelection,  placeholder,  getValue: callback }, props) => {

    const options = useSelector(state => select.selectLocation(state, props))

    const getValue = (value, setFieldValue) => {
        if (callback) {
            callback(value, setFieldValue)
        }
    }

   
    return (
        <Field name={name} isLabel={isLabel} isTxn={isTxn} label={label} placeholder={placeholder} isSelection={isSelection} component={FormikSelectComponent} userProps={{ options, getValue }}> </Field>
       
    )
}

export default LocationSearch;
